import styled from '@emotion/styled';

export const App = styled.div`
  display: flex;
  background:#edf2f9;
  min-height:100vh;
`

export const Header = styled.h1`
  color: pink
`

export const ContentView = styled.div`
  width: 95%;
  padding: 10px;
  border-left:1px solid darkgray;
`